import script from "./VoucherList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherList.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherList.vue?vue&type=style&index=0&id=01033a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01033a08"]])

export default __exports__